import React, { useState } from 'react';
import DataTable from '../../../../shared/ui/DataTable/DataTable';
import useTablePagination from '../../../../shared/hooks/useTablePagination';
import useTableChange from '../../../../shared/hooks/useTableChange';
import useTransportPermitsMatch from '../../../../shared/hooks/useTransportPermitsMatch';
import { sortableColumnsData } from '../../../../shared/constants/sortableColumnsData';
import { getTableColumns } from '../../lib/getTableColumns';
import useGetParamsForRequest from '../../../../shared/hooks/useGetParamsForRequest';
import { useQueryClient } from 'react-query';
import { getQueryKeys } from '../../../../shared/lib/getQueryKeys';
import PermitsExpandedRow from '../PermitsExpandedRow/PermitsExpandedRow';

const PermitsBlock = ({ filteredBySearchPermits = [] }) => {
  const match = useTransportPermitsMatch();

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;

  const paramsRequest = useGetParamsForRequest();

  const queryClient = useQueryClient();

  const {
    data: filteredAndSorted,
    sortedInfo,
    handleTableChange,
    handleSortMode,
    sortMode,
  } = useTableChange({
    initialData: filteredBySearchPermits,
    sortableColumnKeys: sortableColumnsData,
    depsToReset: [urlCompanyId],
  });

  const { shownItems: shownTenants, pagination: paginationBlock } =
    useTablePagination(filteredAndSorted);

  const onSuccessActions = () => {
    queryClient.refetchQueries(getQueryKeys.permits(paramsRequest));
  };

  const columns = getTableColumns({
    sortedInfo,
    handleSortMode,
    sortMode,
    onSuccessActions,
  });

  const removeRowFromSelection = (rowId) => {
    const updateRowKeys = expandedRowKeys.filter((key) => key !== rowId);
    setExpandedRowKeys(updateRowKeys);
  };

  const addRowToSelection = (rowId) => {
    const updateRowKeys = [...expandedRowKeys, rowId];
    setExpandedRowKeys(updateRowKeys);
  };

  const handleRowClick = (rowId) => {
    if (expandedRowKeys.includes(rowId)) {
      removeRowFromSelection(rowId);
    } else {
      addRowToSelection(rowId);
    }
  };

  return (
    <DataTable
      onChange={handleTableChange}
      columns={columns}
      dataSource={shownTenants}
      paginationBlock={paginationBlock}
      expandIconAsCell={false}
      expandedRowKeys={expandedRowKeys}
      expandedRowRender={(record) => <PermitsExpandedRow record={record} />}
      onRow={(record) => ({
        onClick: () => handleRowClick(record?.id),
        expanded: expandedRowKeys.includes(record.id),
      })}
    />
  );
};

export default PermitsBlock;
